import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';

function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [devOtp, setDevOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendOtp = async (e) => {
    e.preventDefault();
    if (mobile.length !== 10) {
      toast.error('10 digit mobile number डालो');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/Auth/forgot-password', { mobile });
      toast.success(res.data.message || 'OTP ready');
      if (res.data.otp) {
        setDevOtp(res.data.otp);
      }
      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (!otp || newPassword.length < 4) {
      toast.error('OTP और नया password (min 4) डालो');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/Auth/reset-password', {
        mobile,
        otp,
        newPassword,
      });
      toast.success(res.data.message || 'Password updated');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold text-center text-blue-700 mb-1">
          Forgot Password
        </h2>
        <p className="text-center text-sm text-gray-500 mb-6">
          {step === 1 ? 'Registered mobile डालो' : 'OTP + नया password'}
        </p>

        {step === 1 && (
          <form onSubmit={sendOtp} className="space-y-4">
            <input
              type="tel"
              maxLength={10}
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
              placeholder="Mobile Number"
              required
              className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl disabled:opacity-50"
            >
              {loading ? 'Please wait...' : 'Get OTP (Free)'}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={resetPassword} className="space-y-4">
            <p className="text-sm text-center text-gray-500">Mobile: {mobile}</p>

            {/* FREE OTP – screen पर */}
            {devOtp && (
              <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-center">
                <p className="text-xs text-green-600">Your OTP (Free – on screen)</p>
                <p className="text-2xl font-bold text-green-700 tracking-widest">
                  {devOtp}
                </p>
                <p className="text-[10px] text-gray-400 mt-1">Valid 10 minutes</p>
              </div>
            )}

            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              required
              className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New Password"
              required
              className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl disabled:opacity-50"
            >
              {loading ? 'Updating...' : 'Update Password'}
            </button>
            <button
              type="button"
              onClick={() => {
                setStep(1);
                setDevOtp('');
                setOtp('');
              }}
              className="w-full text-sm text-gray-500"
            >
              ← Change mobile
            </button>
          </form>
        )}

        <p className="text-center text-sm text-gray-500 mt-4">
          <Link to="/login" className="text-blue-600 font-semibold">
            Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;